/* tslint:disable */
// @ts-ignore

import { requestPlatform } from '@tencent/vb-web-base';
// prettier-ignore
import {IGetActReq, IResponse, IGetActRes, IGenerateInviteCodeRsp, IQuerySpecificInfoRsp, ICheckActivityRuleRsp, IQueryCouponListRsp, IQueryCouponListMultiRsp, IQueryCouponInfoRsp, ICheckInfoRes, IInviteInfoRes, ISetInviteInfoRes, IJoinActRes, IVerifyAuthCodeResp, IRegisterNameListResp, IRightHomeConfig, IRightActDate, IRightList, IGetActivityListResp, IGetActivityRecordResp, ICheckAwardStockResp, IGetRecordListResp, ICheckLoanStatusResp, IMobileRegisterResp, ICheckAllLoanStatusResp, IQueryChargeInfoResp, IQueryContractKeysResp, IEntranceInfo, IWidgetConfItem, IGetTeslaWhiteListResp, IRepayPreDealRsp, ITwsNullResp, ILoanPreData, ILoanData, ICreateLimitCheckRsp, IInterestAndTermsRes, IProductRes, IGetTermsRes, IGetUserLimitInfoListResp, IQuickTransferInfoResp, ISimpleResponse, IUserCheckCancelIncreaseLimitRep, IqueryRedPointConfigResp, IQueryRateRes, IGetAcctWorkInfoRes, IGetUserStatus, IGetProtoConfRes, IGetActConfigRes, IGetCouponListRes, IGetAwardRes, IGetFrozeInfoRes, IGetAcctBalanceRes, IGetActCommonConfigRes, IProductConfItem, IDimProofRes, ICheckDealStatusRes, IBillListRes, IRepayDetail, IInitiativeDetail, IRepayDateResp, IRepayRecent, IRepayBookRes, IInternalCreditCheckRes, IAllProductsBillListRes, IGetAcctRes, IGetDealInfotRes, ITeslaCaptchaCodeResp, IResString, IGetUmUserInfoResp, INoticeChannelResp, ISetNoticeChannelRes, ICheckUserLoanStatusResp, IGetUserInfpResp, ICheckCreateLimitData, ICheckUserLimitData, IGetWhiteListItemResp, IGenerateInviteCodeReq, ICheckActivityRuleReq, IQueryCouponInfoReq, IQueryCouponInfoMultiReq, ICheckInfoReq, IInviteInfoReq, ISetInviteInfoReq, IJoinActReq, ISendAuthCodeReq, IVerifyAuthCodeReq, IRegisterNameListReq, IRegisterNameListSimpleReq, ICheckCarOwnerInfoReq, IQueryCarOwnerInfoReq, IBrandReq, IGetActivityListReq, IGetActivityRecordReq, ICheckAwardStockReq, IGetRecordListReq, IuseAwardReq, IJoinActivityReq, ICheckCarOwnerRightReq, ICheckLoanStatusReq, IMobileRegisterReq, ICheckAllLoanStatusReq, IDownloadQuery, IQueryChargeInfoReq, IQueryContractKeysReq, IGetSwitchConfReq, IPreDealReq, ICreateDealReq, IPreLoanReq, ILoanReq, ICreateLimitCheckReq, ITermsAndInterestReq, IProductListReq, IGetTermsQuery, IGetUserLimitInfoListReq, IGetQuickTransferInfoReq, IUserApplyIncreaseLimitReq, IUserCancelIncreaseLimitReq, ICheckEprcAddressReq, IQueryConfig, IQueryRate, IGetProtoConfReq, IGetActConfigReq, IGetCouponListReq, IGetAwardReq, IGetFrozeInfoReq, IGetAcctBalanceReq, IGetActCommonConfigReq, IProductConfigReq, IProofSaveReq, ICheckProofReuseReq, ICheckDealStatusQuery, ILoanBillListQuery, ILoanDetailQuery, ILoanInitiativeQuery, IRepayDate, IBaseQuery, IRepayBookQuery, IRegisterReq, IGetAcctReq, IGetDealInfotReq, ITeslaCaptchaCodeReq, ITeslaPreRegisterReq, IRegbody, IRegHkbody, ISetNoticeChannelReq, ICheckUserLoanStatusReq, IGetUserInfoReq, IGetUserAdrReq, IRequireReq, ICheckUserLimitReq, IGetWhiteListItemReq} from './index'


// prettier-ignore
const requestPlatformActGetAct = async (query: IGetActReq,) => {
    return await requestPlatform<IResponse<IGetActRes>>(
      '/node/loan/act/getActDetail',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActGenerateInviteCode = async (query: IGenerateInviteCodeReq,) => {
    return await requestPlatform<IResponse<IGenerateInviteCodeRsp>>(
      '/node/loan/act/generateInviteCode',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActQuerySpecificInfo = async () => {
    return await requestPlatform<IResponse<IQuerySpecificInfoRsp>>(
      '/node/loan/act/querySpecificInfo',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformActCheckActivityRule = async (query: ICheckActivityRuleReq,) => {
    return await requestPlatform<IResponse<ICheckActivityRuleRsp>>(
      '/node/loan/act/checkActivityRule',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActQueryCouponList = async (query: IQueryCouponInfoReq,) => {
    return await requestPlatform<IResponse<IQueryCouponListRsp>>(
      '/node/loan/act/queryCouponList',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActQueryCouponListMulti = async (body: IQueryCouponInfoMultiReq,) => {
    return await requestPlatform<IResponse<IQueryCouponListMultiRsp>>(
      '/node/loan/act/queryCouponListMulti',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformActQueryCoupon = async (query: IQueryCouponInfoReq,) => {
    return await requestPlatform<IResponse<IQueryCouponInfoRsp>>(
      '/node/loan/act/queryCoupon',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActCheckInviteCode = async (query: ICheckInfoReq,) => {
    return await requestPlatform<IResponse<ICheckInfoRes>>(
      '/node/loan/act/checkInviteCode',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActGetInviteInfo = async (query: IInviteInfoReq,) => {
    return await requestPlatform<IResponse<IInviteInfoRes>>(
      '/node/loan/act/getInviteInfo',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActSetInviteCode = async (query: ISetInviteInfoReq,) => {
    return await requestPlatform<ISetInviteInfoRes>(
      '/node/loan/act/setInviteCode',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformActGetRetainCoupon = async (body: IJoinActReq,) => {
    return await requestPlatform<IJoinActRes>(
      '/node/loan/act/getRetainCoupon',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformActSendAuthCode = async (body: ISendAuthCodeReq,) => {
    return await requestPlatform<any>(
      '/node/loan/act/sendAuthCode',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformActVerifyAuthCode = async (body: IVerifyAuthCodeReq,) => {
    return await requestPlatform<IResponse<IVerifyAuthCodeResp>>(
      '/node/loan/act/verifyAuthCode',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformActRegisterNameList = async (body: IRegisterNameListReq,) => {
    return await requestPlatform<IResponse<IRegisterNameListResp>>(
      '/node/loan/act/registerNameList',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformActRegisterNameListSimple = async (body: IRegisterNameListSimpleReq,) => {
    return await requestPlatform<IResponse<IRegisterNameListResp>>(
      '/node/loan/act/registerNameListSimple',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformCarOwnerCarBrandOptions = async () => {
    return await requestPlatform<any>(
      '/node/loan/carOwner/carBrandOptions',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformCarOwnerCheckCarOwnerInfo = async (query: ICheckCarOwnerInfoReq,) => {
    return await requestPlatform<any>(
      '/node/loan/carOwner/checkCarOwnerInfo',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerCheckTeslaWhiteAndOwnerInfo = async () => {
    return await requestPlatform<any>(
      '/node/loan/carOwner/checkTeslaWhiteAndOwnerInfo',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformCarOwnerCheckNoTeslaWhite = async () => {
    return await requestPlatform<any>(
      '/node/loan/carOwner/checkNoTeslaWhiteAndIsElectricCar',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformCarOwnerQueryCarOwnerInfo = async (query: IQueryCarOwnerInfoReq,) => {
    return await requestPlatform<any>(
      '/node/loan/carOwner/queryCarOwnerInfo',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightGetHomeConfig = async (query: IBrandReq,) => {
    return await requestPlatform<IResponse<IRightHomeConfig>>(
      '/node/loan/carOwnerRight/getHomeConfig',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightGetActDate = async (query: IBrandReq,) => {
    return await requestPlatform<IResponse<IRightActDate>>(
      '/node/loan/carOwnerRight/getActDate',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightGetRightList = async (query: IBrandReq,) => {
    return await requestPlatform<IResponse<IRightList>>(
      '/node/loan/carOwnerRight/getRightList',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightGetActivityList = async (query: IGetActivityListReq,) => {
    return await requestPlatform<IResponse<IGetActivityListResp>>(
      '/node/loan/carOwnerRight/getActivityList',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightGetActivityRecoed = async (body: IGetActivityRecordReq,) => {
    return await requestPlatform<IResponse<IGetActivityRecordResp>>(
      '/node/loan/carOwnerRight/getActivityRecoed',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightGetAwardConf = async (query: ICheckAwardStockReq,) => {
    return await requestPlatform<IResponse<ICheckAwardStockResp>>(
      '/node/loan/carOwnerRight/checkAwardStock',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightGetRecordList = async (body: IGetRecordListReq,) => {
    return await requestPlatform<IResponse<IGetRecordListResp>>(
      '/node/loan/carOwnerRight/getRecordList',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightUseAward = async (body: IuseAwardReq,) => {
    return await requestPlatform<any>(
      '/node/loan/carOwnerRight/useAward',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightJoinActivity = async (body: IJoinActivityReq,) => {
    return await requestPlatform<any>(
      '/node/loan/carOwnerRight/joinActivity',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightCheckCarOwnerRight = async (query: ICheckCarOwnerRightReq,) => {
    return await requestPlatform<IResponse<ICheckLoanStatusResp>>(
      '/node/loan/carOwnerRight/checkCarOwnerRight',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightCheckLoanStatus = async (query: ICheckLoanStatusReq,) => {
    return await requestPlatform<IResponse<ICheckLoanStatusResp>>(
      '/node/loan/carOwnerRight/checkLoanStatus',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightRegister = async (body: IMobileRegisterReq,) => {
    return await requestPlatform<IResponse<IMobileRegisterResp>>(
      '/node/loan/carOwnerRight/registerMobile',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformCarOwnerRightCheckAllLoanStatus = async (body: ICheckAllLoanStatusReq,) => {
    return await requestPlatform<IResponse<ICheckAllLoanStatusResp>>(
      '/node/loan/carOwnerRight/checkAllLoanStatus',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformCommonDownloadNotice = async (query: IDownloadQuery,) => {
    return await requestPlatform<any>(
      '/node/loan/common/notice',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCommonGetAcct = async () => {
    return await requestPlatform<any>(
      '/node/loan/common/getAcct',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformCommonQueryChargeInfo = async (query: IQueryChargeInfoReq,) => {
    return await requestPlatform<IResponse<IQueryChargeInfoResp>>(
      '/node/loan/common/queryChargeInfo',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformCommonGetContractKeys = async (query: IQueryContractKeysReq,) => {
    return await requestPlatform<IQueryContractKeysResp>(
      '/node/loan/common/getContractKeys',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformHomeGetEntrance = async () => {
    return await requestPlatform<IResponse<IEntranceInfo>>(
      '/node/loan/home/getEntrance',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformHomeIndex = async () => {
    return await requestPlatform<IResponse<IWidgetConfItem>>(
      '/node/loan/home/index',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformHomeGetSwitchConf = async (query: IGetSwitchConfReq,) => {
    return await requestPlatform<any>(
      '/node/loan/home/getSwitchConf',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformHomeGetTeslaWhiteList = async () => {
    return await requestPlatform<IResponse<IGetTeslaWhiteListResp>>(
      '/node/loan/home/getTeslaWhiteList',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformJavaCreateRepayPreDeal = async (body: IPreDealReq,) => {
    return await requestPlatform<IResponse<IRepayPreDealRsp>>(
      '/java/loan/core/repayMoneyPreDeal',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformJavaCreateRepayDeal = async (body: ICreateDealReq,) => {
    return await requestPlatform<ITwsNullResp>(
      '/java/loan/core/repayMoneyCreateDeal',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformJavaCreateLoanPre = async (body: IPreLoanReq,) => {
    return await requestPlatform<IResponse<ILoanPreData>>(
      '/java/loan/core/withdrawMoneyPreDeal',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformJavaCreateLoan = async (body: ILoanReq,) => {
    return await requestPlatform<IResponse<ILoanData>>(
      '/java/loan/core/withdrawMoneyCreateDeal',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformLoanCreateLimitCheck = async (query: ICreateLimitCheckReq,) => {
    return await requestPlatform<IResponse<ICreateLimitCheckRsp>>(
      '/node/loan/loan/createLimitCheck',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanTermsAndInterest = async (query: ITermsAndInterestReq,) => {
    return await requestPlatform<IResponse<IInterestAndTermsRes>>(
      '/node/loan/loan/termsAndInterest',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanGetProduct = async (query: IProductListReq,) => {
    return await requestPlatform<IResponse<IProductRes>>(
      '/node/loan/loan/product',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanGetTerms = async (query: IGetTermsQuery,) => {
    return await requestPlatform<IResponse<IGetTermsRes>>(
      '/node/loan/loan/terms',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanGetUserLimitInfoList = async (query: IGetUserLimitInfoListReq,) => {
    return await requestPlatform<IResponse<IGetUserLimitInfoListResp>>(
      '/node/loan/loan/userLimitInfoList',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanGetQuickTransferInfo = async (query: IGetQuickTransferInfoReq,) => {
    return await requestPlatform<IResponse<IQuickTransferInfoResp>>(
      '/node/loan/loan/quickTransferInfo',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanUserApplyIncreaseLimit = async (body: IUserApplyIncreaseLimitReq,) => {
    return await requestPlatform<ISimpleResponse>(
      '/node/loan/loan/userApplyIncreaseLimit',
      'GET', body
    );
  };
// prettier-ignore
const requestPlatformLoanCheckCancelIncreaseLimit = async (query: IUserCancelIncreaseLimitReq,) => {
    return await requestPlatform<IResponse<IUserCheckCancelIncreaseLimitRep>>(
      '/node/loan/loan/checkCancelIncreaseLimit',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanCancelIncreaseLimit = async (query: IUserCancelIncreaseLimitReq,) => {
    return await requestPlatform<ISimpleResponse>(
      '/node/loan/loan/cancelIncreaseLimit',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanCheckEprcAddress = async (query: ICheckEprcAddressReq,) => {
    return await requestPlatform<ISimpleResponse>(
      '/node/loan/loan/checkEprcAddress',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanConfigQueryConfigList = async (query: IQueryConfig,) => {
    return await requestPlatform<any>(
      '/node/loan/loanConfig/queryConfigList',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformLoanConfigQueryRedPointConfig = async () => {
    return await requestPlatform<IResponse<IqueryRedPointConfigResp>>(
      '/node/loan/loanConfig/queryRedPointConfig',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformLoanConfigQueryInstallmentRate = async (query: IQueryRate,) => {
    return await requestPlatform<IResponse<IQueryRateRes>>(
      '/node/loan/loanConfig/queryInstallmentRate',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformNodeGetWorkInfo = async () => {
    return await requestPlatform<IResponse<IGetAcctWorkInfoRes>>(
      '/node/account/getWorkInfo',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformNodeGetUserStatus = async () => {
    return await requestPlatform<IResponse<IGetUserStatus>>(
      '/node/account/user/status',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformNodeGetProtoConf = async (query: IGetProtoConfReq,) => {
    return await requestPlatform<IGetProtoConfRes>(
      '/node/common/contract/protoConf',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformNodeGetActConfig = async (query: IGetActConfigReq,) => {
    return await requestPlatform<IGetActConfigRes>(
      '/node/act/getConfig',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformNodeGetCouponList = async (query: IGetCouponListReq,) => {
    return await requestPlatform<IResponse<IGetCouponListRes>>(
      '/node/account/coupon/list',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformNodeGetAwardDetail = async (query: IGetAwardReq,) => {
    return await requestPlatform<IResponse<IGetAwardRes>>(
      '/node/account/coupon/awardDetail',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformNodeGetFrozeInfo = async (query: IGetFrozeInfoReq,) => {
    return await requestPlatform<IGetFrozeInfoRes>(
      '/node/account/user/status/froze',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformNodeGetAcctBalance = async (query: IGetAcctBalanceReq,) => {
    return await requestPlatform<IResponse<IGetAcctBalanceRes>>(
      '/node/account/sub/list',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformNodeGetActCommonConfig = async (query: IGetActCommonConfigReq,) => {
    return await requestPlatform<IResponse<IGetActCommonConfigRes>>(
      '/node/activity/ticket/config',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformProductGetConfigs = async (query: IProductConfigReq,) => {
    return await requestPlatform<IResponse<IProductConfItem>>(
      '/node/loan/product/configs',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformProofSave = async (body: IProofSaveReq,) => {
    return await requestPlatform<ISimpleResponse>(
      '/node/loan/proof/save',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformProofQueyDimProof = async () => {
    return await requestPlatform<IResponse<IDimProofRes>>(
      '/node/loan/proof/queyDimProof',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformProofCheckProofReuse = async (query: ICheckProofReuseReq,) => {
    return await requestPlatform<any>(
      '/node/loan/proof/checkProofReuse',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayCheckLoanStatus = async (query: ICheckDealStatusQuery,) => {
    return await requestPlatform<IResponse<ICheckDealStatusRes>>(
      '/node/loan/repay/checkLoanStatus',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayCheckRepayStatus = async (query: ICheckDealStatusQuery,) => {
    return await requestPlatform<IResponse<ICheckDealStatusRes>>(
      '/node/loan/repay/checkRepayStatus',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayGetLoanBillList = async (query: ILoanBillListQuery,) => {
    return await requestPlatform<IResponse<IBillListRes>>(
      '/node/loan/repay/bills',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayGetAllBillList = async (query: ILoanBillListQuery,) => {
    return await requestPlatform<IResponse<IBillListRes>>(
      '/node/loan/repay/allBills',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayGetLoanDetail = async (query: ILoanDetailQuery,) => {
    return await requestPlatform<IResponse<IRepayDetail>>(
      '/node/loan/repay/loan',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayLoanInitiative = async (query: ILoanInitiativeQuery,) => {
    return await requestPlatform<IResponse<IInitiativeDetail>>(
      '/node/loan/repay/initiative',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayGetRepayDate = async (query: IRepayDate,) => {
    return await requestPlatform<IResponse<IRepayDateResp>>(
      '/node/loan/repay/repayDate',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayGetRepayRecent = async (query: IBaseQuery,) => {
    return await requestPlatform<IResponse<IRepayRecent>>(
      '/node/loan/repay/recent',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayGetRepayBook = async (query: IRepayBookQuery,) => {
    return await requestPlatform<IResponse<IRepayBookRes>>(
      '/node/loan/repay/repayBook',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformRepayInternalCreditCheck = async () => {
    return await requestPlatform<IResponse<IInternalCreditCheckRes>>(
      '/node/loan/repay/internalCreditCheck',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformRepayGetAllProductsBillList = async () => {
    return await requestPlatform<IResponse<IAllProductsBillListRes>>(
      '/node/loan/repay/allProductsBills',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformTeslaRegister = async (body: IRegisterReq,) => {
    return await requestPlatform<ISimpleResponse>(
      '/node/loan/tesla/register',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformTeslaGetAcct = async (query: IGetAcctReq,) => {
    return await requestPlatform<IGetAcctRes>(
      '/node/loan/tesla/getAcct',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformTeslaGetDealInfo = async (query: IGetDealInfotReq,) => {
    return await requestPlatform<IGetDealInfotRes>(
      '/node/loan/tesla/getDealInfo',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformTeslaPreRegisterUserCheck = async () => {
    return await requestPlatform<any>(
      '/node/loan/teslaPreRegister/userCheck',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformTeslaPreRegisterGetCaptchaCode = async (body: ITeslaCaptchaCodeReq,) => {
    return await requestPlatform<ITeslaCaptchaCodeResp>(
      '/node/loan/teslaPreRegister/getCaptchaCode',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformTeslaPreRegisterRegister = async (body: ITeslaPreRegisterReq,) => {
    return await requestPlatform<ISimpleResponse>(
      '/node/loan/teslaPreRegister/register',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformTokenIdenInfo = async (body: IRegbody,) => {
    return await requestPlatform<IResString>(
      '/node/loan/token/idenInfo',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformTokenIdenInfoHk = async (body: IRegHkbody,) => {
    return await requestPlatform<IResString>(
      '/node/loan/token/idenInfoHk',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformUmGetUmUserInfo = async () => {
    return await requestPlatform<IResponse<IGetUmUserInfoResp>>(
      '/um/mgr/user/info',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformUmQryNoticeChannel = async () => {
    return await requestPlatform<IResponse<INoticeChannelResp>>(
      '/um/mgr/user/qryNoticeChannel',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformUmSetNoticeChannel = async (body: ISetNoticeChannelReq,) => {
    return await requestPlatform<IResponse<ISetNoticeChannelRes>>(
      '/um/mgr/user/changeNoticeChannel',
      'POST', body
    );
  };
// prettier-ignore
const requestPlatformUserCheckStatus = async (query: ICheckUserLoanStatusReq,) => {
    return await requestPlatform<IResponse<ICheckUserLoanStatusResp>>(
      '/node/loan/user/checkStatus',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformUserGetUserInfo = async (query: IGetUserInfoReq,) => {
    return await requestPlatform<IResponse<IGetUserInfpResp>>(
      '/node/loan/user/getUserInfo',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformUserGetUserAdr = async (query: IGetUserAdrReq,) => {
    return await requestPlatform<IResponse<IGetUserInfpResp>>(
      '/node/loan/user/getUserAdr',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformUserGetOpenAcctInfo = async () => {
    return await requestPlatform<any>(
      '/node/loan/user/qryUserInfo',
      'GET', 
    );
  };
// prettier-ignore
const requestPlatformUserCheckCreateLimit = async (query: IRequireReq,) => {
    return await requestPlatform<IResponse<ICheckCreateLimitData>>(
      '/node/loan/user/checkCreateLimit',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformUserCheckUserLimit = async (query: ICheckUserLimitReq,) => {
    return await requestPlatform<IResponse<ICheckUserLimitData>>(
      '/node/loan/user/checkUserLimit',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformUserGetWhiteListItem = async (query: IGetWhiteListItemReq,) => {
    return await requestPlatform<IResponse<IGetWhiteListItemResp>>(
      '/node/loan/user/getWhiteListItem',
      'GET', query
    );
  };
// prettier-ignore
const requestPlatformWxWxPolicy = async () => {
    return await requestPlatform<any>(
      '/node/loan/wx/wxPolicy',
      'GET', 
    );
  };

// prettier-ignore
export default {
	act: {
		requestPlatformActGetAct: requestPlatformActGetAct,
		requestPlatformActGenerateInviteCode: requestPlatformActGenerateInviteCode,
		requestPlatformActQuerySpecificInfo: requestPlatformActQuerySpecificInfo,
		requestPlatformActCheckActivityRule: requestPlatformActCheckActivityRule,
		requestPlatformActQueryCouponList: requestPlatformActQueryCouponList,
		requestPlatformActQueryCouponListMulti: requestPlatformActQueryCouponListMulti,
		requestPlatformActQueryCoupon: requestPlatformActQueryCoupon,
		requestPlatformActCheckInviteCode: requestPlatformActCheckInviteCode,
		requestPlatformActGetInviteInfo: requestPlatformActGetInviteInfo,
		requestPlatformActSetInviteCode: requestPlatformActSetInviteCode,
		requestPlatformActGetRetainCoupon: requestPlatformActGetRetainCoupon,
		requestPlatformActSendAuthCode: requestPlatformActSendAuthCode,
		requestPlatformActVerifyAuthCode: requestPlatformActVerifyAuthCode,
		requestPlatformActRegisterNameList: requestPlatformActRegisterNameList,
		requestPlatformActRegisterNameListSimple: requestPlatformActRegisterNameListSimple
	},
	carOwner: {
		requestPlatformCarOwnerCarBrandOptions: requestPlatformCarOwnerCarBrandOptions,
		requestPlatformCarOwnerCheckCarOwnerInfo: requestPlatformCarOwnerCheckCarOwnerInfo,
		requestPlatformCarOwnerCheckTeslaWhiteAndOwnerInfo: requestPlatformCarOwnerCheckTeslaWhiteAndOwnerInfo,
		requestPlatformCarOwnerCheckNoTeslaWhite: requestPlatformCarOwnerCheckNoTeslaWhite,
		requestPlatformCarOwnerQueryCarOwnerInfo: requestPlatformCarOwnerQueryCarOwnerInfo
	},
	carOwnerRight: {
		requestPlatformCarOwnerRightGetHomeConfig: requestPlatformCarOwnerRightGetHomeConfig,
		requestPlatformCarOwnerRightGetActDate: requestPlatformCarOwnerRightGetActDate,
		requestPlatformCarOwnerRightGetRightList: requestPlatformCarOwnerRightGetRightList,
		requestPlatformCarOwnerRightGetActivityList: requestPlatformCarOwnerRightGetActivityList,
		requestPlatformCarOwnerRightGetActivityRecoed: requestPlatformCarOwnerRightGetActivityRecoed,
		requestPlatformCarOwnerRightGetAwardConf: requestPlatformCarOwnerRightGetAwardConf,
		requestPlatformCarOwnerRightGetRecordList: requestPlatformCarOwnerRightGetRecordList,
		requestPlatformCarOwnerRightUseAward: requestPlatformCarOwnerRightUseAward,
		requestPlatformCarOwnerRightJoinActivity: requestPlatformCarOwnerRightJoinActivity,
		requestPlatformCarOwnerRightCheckCarOwnerRight: requestPlatformCarOwnerRightCheckCarOwnerRight,
		requestPlatformCarOwnerRightCheckLoanStatus: requestPlatformCarOwnerRightCheckLoanStatus,
		requestPlatformCarOwnerRightRegister: requestPlatformCarOwnerRightRegister,
		requestPlatformCarOwnerRightCheckAllLoanStatus: requestPlatformCarOwnerRightCheckAllLoanStatus
	},
	common: {
		requestPlatformCommonDownloadNotice: requestPlatformCommonDownloadNotice,
		requestPlatformCommonGetAcct: requestPlatformCommonGetAcct,
		requestPlatformCommonQueryChargeInfo: requestPlatformCommonQueryChargeInfo,
		requestPlatformCommonGetContractKeys: requestPlatformCommonGetContractKeys
	},
	home: {
		requestPlatformHomeGetEntrance: requestPlatformHomeGetEntrance,
		requestPlatformHomeIndex: requestPlatformHomeIndex,
		requestPlatformHomeGetSwitchConf: requestPlatformHomeGetSwitchConf,
		requestPlatformHomeGetTeslaWhiteList: requestPlatformHomeGetTeslaWhiteList
	},
	java: {
		requestPlatformJavaCreateRepayPreDeal: requestPlatformJavaCreateRepayPreDeal,
		requestPlatformJavaCreateRepayDeal: requestPlatformJavaCreateRepayDeal,
		requestPlatformJavaCreateLoanPre: requestPlatformJavaCreateLoanPre,
		requestPlatformJavaCreateLoan: requestPlatformJavaCreateLoan
	},
	loan: {
		requestPlatformLoanCreateLimitCheck: requestPlatformLoanCreateLimitCheck,
		requestPlatformLoanTermsAndInterest: requestPlatformLoanTermsAndInterest,
		requestPlatformLoanGetProduct: requestPlatformLoanGetProduct,
		requestPlatformLoanGetTerms: requestPlatformLoanGetTerms,
		requestPlatformLoanGetUserLimitInfoList: requestPlatformLoanGetUserLimitInfoList,
		requestPlatformLoanGetQuickTransferInfo: requestPlatformLoanGetQuickTransferInfo,
		requestPlatformLoanUserApplyIncreaseLimit: requestPlatformLoanUserApplyIncreaseLimit,
		requestPlatformLoanCheckCancelIncreaseLimit: requestPlatformLoanCheckCancelIncreaseLimit,
		requestPlatformLoanCancelIncreaseLimit: requestPlatformLoanCancelIncreaseLimit,
		requestPlatformLoanCheckEprcAddress: requestPlatformLoanCheckEprcAddress
	},
	loanConfig: {
		requestPlatformLoanConfigQueryConfigList: requestPlatformLoanConfigQueryConfigList,
		requestPlatformLoanConfigQueryRedPointConfig: requestPlatformLoanConfigQueryRedPointConfig,
		requestPlatformLoanConfigQueryInstallmentRate: requestPlatformLoanConfigQueryInstallmentRate
	},
	node: {
		requestPlatformNodeGetWorkInfo: requestPlatformNodeGetWorkInfo,
		requestPlatformNodeGetUserStatus: requestPlatformNodeGetUserStatus,
		requestPlatformNodeGetProtoConf: requestPlatformNodeGetProtoConf,
		requestPlatformNodeGetActConfig: requestPlatformNodeGetActConfig,
		requestPlatformNodeGetCouponList: requestPlatformNodeGetCouponList,
		requestPlatformNodeGetAwardDetail: requestPlatformNodeGetAwardDetail,
		requestPlatformNodeGetFrozeInfo: requestPlatformNodeGetFrozeInfo,
		requestPlatformNodeGetAcctBalance: requestPlatformNodeGetAcctBalance,
		requestPlatformNodeGetActCommonConfig: requestPlatformNodeGetActCommonConfig
	},
	product: {
		requestPlatformProductGetConfigs: requestPlatformProductGetConfigs
	},
	proof: {
		requestPlatformProofSave: requestPlatformProofSave,
		requestPlatformProofQueyDimProof: requestPlatformProofQueyDimProof,
		requestPlatformProofCheckProofReuse: requestPlatformProofCheckProofReuse
	},
	repay: {
		requestPlatformRepayCheckLoanStatus: requestPlatformRepayCheckLoanStatus,
		requestPlatformRepayCheckRepayStatus: requestPlatformRepayCheckRepayStatus,
		requestPlatformRepayGetLoanBillList: requestPlatformRepayGetLoanBillList,
		requestPlatformRepayGetAllBillList: requestPlatformRepayGetAllBillList,
		requestPlatformRepayGetLoanDetail: requestPlatformRepayGetLoanDetail,
		requestPlatformRepayLoanInitiative: requestPlatformRepayLoanInitiative,
		requestPlatformRepayGetRepayDate: requestPlatformRepayGetRepayDate,
		requestPlatformRepayGetRepayRecent: requestPlatformRepayGetRepayRecent,
		requestPlatformRepayGetRepayBook: requestPlatformRepayGetRepayBook,
		requestPlatformRepayInternalCreditCheck: requestPlatformRepayInternalCreditCheck,
		requestPlatformRepayGetAllProductsBillList: requestPlatformRepayGetAllProductsBillList
	},
	tesla: {
		requestPlatformTeslaRegister: requestPlatformTeslaRegister,
		requestPlatformTeslaGetAcct: requestPlatformTeslaGetAcct,
		requestPlatformTeslaGetDealInfo: requestPlatformTeslaGetDealInfo
	},
	teslaPreRegister: {
		requestPlatformTeslaPreRegisterUserCheck: requestPlatformTeslaPreRegisterUserCheck,
		requestPlatformTeslaPreRegisterGetCaptchaCode: requestPlatformTeslaPreRegisterGetCaptchaCode,
		requestPlatformTeslaPreRegisterRegister: requestPlatformTeslaPreRegisterRegister
	},
	token: {
		requestPlatformTokenIdenInfo: requestPlatformTokenIdenInfo,
		requestPlatformTokenIdenInfoHk: requestPlatformTokenIdenInfoHk
	},
	um: {
		requestPlatformUmGetUmUserInfo: requestPlatformUmGetUmUserInfo,
		requestPlatformUmQryNoticeChannel: requestPlatformUmQryNoticeChannel,
		requestPlatformUmSetNoticeChannel: requestPlatformUmSetNoticeChannel
	},
	user: {
		requestPlatformUserCheckStatus: requestPlatformUserCheckStatus,
		requestPlatformUserGetUserInfo: requestPlatformUserGetUserInfo,
		requestPlatformUserGetUserAdr: requestPlatformUserGetUserAdr,
		requestPlatformUserGetOpenAcctInfo: requestPlatformUserGetOpenAcctInfo,
		requestPlatformUserCheckCreateLimit: requestPlatformUserCheckCreateLimit,
		requestPlatformUserCheckUserLimit: requestPlatformUserCheckUserLimit,
		requestPlatformUserGetWhiteListItem: requestPlatformUserGetWhiteListItem
	},
	wx: {
		requestPlatformWxWxPolicy: requestPlatformWxWxPolicy
	}
}
